import { render } from "./entity_type_attributes.html?vue&type=template&id=1f078312&scoped=true&external"
import script from "./entity_type_attributes.js?vue&type=script&lang=js&external"
export * from "./entity_type_attributes.js?vue&type=script&lang=js&external"

import "./EntityTypeAttributes.vue?vue&type=style&index=0&id=1f078312&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f078312"]])

export default __exports__